// EchoFloat signaling protocol v1 — WSS, binary protobuf frames.
// Source of truth: docs/protocol.md §1. One WS binary frame = one envelope.

// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file echo/signal/v1/signal.proto (package echo.signal.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file echo/signal/v1/signal.proto.
 */
export const file_echo_signal_v1_signal: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message echo.signal.v1.ClientMessage
 */
export type ClientMessage = Message<"echo.signal.v1.ClientMessage"> & {
  /**
   * @generated from oneof echo.signal.v1.ClientMessage.msg
   */
  msg: {
    /**
     * @generated from field: echo.signal.v1.Hello hello = 1;
     */
    value: Hello;
    case: "hello";
  } | {
    /**
     * @generated from field: echo.signal.v1.Auth auth = 2;
     */
    value: Auth;
    case: "auth";
  } | {
    /**
     * @generated from field: echo.signal.v1.JoinChannel join_channel = 3;
     */
    value: JoinChannel;
    case: "joinChannel";
  } | {
    /**
     * @generated from field: echo.signal.v1.LeaveChannel leave_channel = 4;
     */
    value: LeaveChannel;
    case: "leaveChannel";
  } | {
    /**
     * @generated from field: echo.signal.v1.VoiceStats voice_stats = 5;
     */
    value: VoiceStats;
    case: "voiceStats";
  } | {
    /**
     * @generated from field: echo.signal.v1.ResumeSession resume_session = 6;
     */
    value: ResumeSession;
    case: "resumeSession";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsKeyPackage mls_key_package = 7;
     */
    value: MlsKeyPackage;
    case: "mlsKeyPackage";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsCommitBundle mls_commit_bundle = 8;
     */
    value: MlsCommitBundle;
    case: "mlsCommitBundle";
  } | {
    /**
     * @generated from field: echo.signal.v1.VoiceState voice_state = 9;
     */
    value: VoiceState;
    case: "voiceState";
  } | {
    /**
     * @generated from field: echo.signal.v1.ScreenShareState screen_share_state = 10;
     */
    value: ScreenShareState;
    case: "screenShareState";
  } | {
    /**
     * @generated from field: echo.signal.v1.ScreenShareStats screen_share_stats = 11;
     */
    value: ScreenShareStats;
    case: "screenShareStats";
  } | {
    /**
     * @generated from field: echo.signal.v1.ChannelReady channel_ready = 12;
     */
    value: ChannelReady;
    case: "channelReady";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.signal.v1.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 0);

/**
 * @generated from message echo.signal.v1.ServerMessage
 */
export type ServerMessage = Message<"echo.signal.v1.ServerMessage"> & {
  /**
   * @generated from oneof echo.signal.v1.ServerMessage.msg
   */
  msg: {
    /**
     * @generated from field: echo.signal.v1.HelloAck hello_ack = 1;
     */
    value: HelloAck;
    case: "helloAck";
  } | {
    /**
     * @generated from field: echo.signal.v1.AuthAck auth_ack = 2;
     */
    value: AuthAck;
    case: "authAck";
  } | {
    /**
     * @generated from field: echo.signal.v1.JoinAccept join_accept = 3;
     */
    value: JoinAccept;
    case: "joinAccept";
  } | {
    /**
     * @generated from field: echo.signal.v1.JoinReject join_reject = 4;
     */
    value: JoinReject;
    case: "joinReject";
  } | {
    /**
     * @generated from field: echo.signal.v1.UserJoined user_joined = 5;
     */
    value: UserJoined;
    case: "userJoined";
  } | {
    /**
     * @generated from field: echo.signal.v1.UserLeft user_left = 6;
     */
    value: UserLeft;
    case: "userLeft";
  } | {
    /**
     * @generated from field: echo.signal.v1.ServerMuteChanged server_mute_changed = 7;
     */
    value: ServerMuteChanged;
    case: "serverMuteChanged";
  } | {
    /**
     * @generated from field: echo.signal.v1.SessionResumed session_resumed = 8;
     */
    value: SessionResumed;
    case: "sessionResumed";
  } | {
    /**
     * @generated from field: echo.signal.v1.Error error = 9;
     */
    value: Error;
    case: "error";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsAddRequest mls_add_request = 10;
     */
    value: MlsAddRequest;
    case: "mlsAddRequest";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsRemoveRequest mls_remove_request = 11;
     */
    value: MlsRemoveRequest;
    case: "mlsRemoveRequest";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsCommit mls_commit = 12;
     */
    value: MlsCommit;
    case: "mlsCommit";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsWelcome mls_welcome = 13;
     */
    value: MlsWelcome;
    case: "mlsWelcome";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsCommitReject mls_commit_reject = 14;
     */
    value: MlsCommitReject;
    case: "mlsCommitReject";
  } | {
    /**
     * @generated from field: echo.signal.v1.MlsReset mls_reset = 15;
     */
    value: MlsReset;
    case: "mlsReset";
  } | {
    /**
     * @generated from field: echo.signal.v1.PeerStats peer_stats = 16;
     */
    value: PeerStats;
    case: "peerStats";
  } | {
    /**
     * @generated from field: echo.signal.v1.ChannelDeleted channel_deleted = 17;
     */
    value: ChannelDeleted;
    case: "channelDeleted";
  } | {
    /**
     * @generated from field: echo.signal.v1.CallEnded call_ended = 18;
     */
    value: CallEnded;
    case: "callEnded";
  } | {
    /**
     * @generated from field: echo.signal.v1.PeerVoiceState peer_voice_state = 19;
     */
    value: PeerVoiceState;
    case: "peerVoiceState";
  } | {
    /**
     * @generated from field: echo.signal.v1.PeerScreenShare peer_screen_share = 20;
     */
    value: PeerScreenShare;
    case: "peerScreenShare";
  } | {
    /**
     * @generated from field: echo.signal.v1.ScreenShareRejected screen_share_rejected = 21;
     */
    value: ScreenShareRejected;
    case: "screenShareRejected";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.signal.v1.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 1);

/**
 * @generated from message echo.signal.v1.Hello
 */
export type Hello = Message<"echo.signal.v1.Hello"> & {
  /**
   * must equal wire::PROTO_VER; mismatch => Error + close
   *
   * @generated from field: uint32 proto_ver = 1;
   */
  protoVer: number;

  /**
   * @generated from field: string client_ver = 2;
   */
  clientVer: string;

  /**
   * Bitset of what this build can do. Bit 0 (CAP_VIEW_SCREEN_SHARE) is its
   * first live use (screenshare-plan.md D91): an old client physically cannot
   * render a message whose existence it does not know about — prost hands it an
   * empty oneof — so "show it an explanation" is impossible. What is possible
   * is telling the person about to start a stream which participants will not
   * see it, before they start explaining slides over it.
   * The bit values live in `echo_wire::caps` rather than in an enum here: a
   * proto3 enum has to start at zero, and a zero-valued "bit" in a bitset is a
   * trap waiting for somebody to write `caps & CAPS_UNSPECIFIED`.
   *
   * @generated from field: uint64 caps = 3;
   */
  caps: bigint;
};

/**
 * Describes the message echo.signal.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema: GenMessage<Hello> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 2);

/**
 * @generated from message echo.signal.v1.HelloAck
 */
export type HelloAck = Message<"echo.signal.v1.HelloAck"> & {
  /**
   * unix millis
   *
   * @generated from field: uint64 server_time_ms = 1;
   */
  serverTimeMs: bigint;

  /**
   * @generated from field: uint64 caps = 2;
   */
  caps: bigint;

  /**
   * @generated from field: string server_ver = 3;
   */
  serverVer: string;
};

/**
 * Describes the message echo.signal.v1.HelloAck.
 * Use `create(HelloAckSchema)` to create a new message.
 */
export const HelloAckSchema: GenMessage<HelloAck> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 3);

/**
 * @generated from message echo.signal.v1.Auth
 */
export type Auth = Message<"echo.signal.v1.Auth"> & {
  /**
   * @generated from field: string jwt = 1;
   */
  jwt: string;
};

/**
 * Describes the message echo.signal.v1.Auth.
 * Use `create(AuthSchema)` to create a new message.
 */
export const AuthSchema: GenMessage<Auth> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 4);

/**
 * @generated from message echo.signal.v1.AuthAck
 */
export type AuthAck = Message<"echo.signal.v1.AuthAck"> & {
  /**
   * @generated from field: uint64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * for ResumeSession after WS drop
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;
};

/**
 * Describes the message echo.signal.v1.AuthAck.
 * Use `create(AuthAckSchema)` to create a new message.
 */
export const AuthAckSchema: GenMessage<AuthAck> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 5);

/**
 * C -> GW after a WS drop, on the fresh connection right after Auth
 * (Hello -> Auth -> ResumeSession). While the grace period (30s) runs, the
 * dropped session keeps its channel membership: no UserLeft, no MLS remove,
 * SFU media untouched; server messages are buffered (bounded). Success =>
 * SessionResumed + the buffered backlog; failure => Error{code=6}, the
 * client falls back to a full re-join. docs/protocol.md §1 Reconnect.
 *
 * @generated from message echo.signal.v1.ResumeSession
 */
export type ResumeSession = Message<"echo.signal.v1.ResumeSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message echo.signal.v1.ResumeSession.
 * Use `create(ResumeSessionSchema)` to create a new message.
 */
export const ResumeSessionSchema: GenMessage<ResumeSession> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 6);

/**
 * @generated from message echo.signal.v1.SessionResumed
 */
export type SessionResumed = Message<"echo.signal.v1.SessionResumed"> & {
};

/**
 * Describes the message echo.signal.v1.SessionResumed.
 * Use `create(SessionResumedSchema)` to create a new message.
 */
export const SessionResumedSchema: GenMessage<SessionResumed> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 7);

/**
 * @generated from message echo.signal.v1.JoinChannel
 */
export type JoinChannel = Message<"echo.signal.v1.JoinChannel"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * Fresh MLS KeyPackage (serialized MlsMessageOut), consumed by this join:
   * GW hands it to the designated committer for Commit(Add). protocol.md §4.
   *
   * @generated from field: bytes mls_key_package = 2;
   */
  mlsKeyPackage: Uint8Array;

  /**
   * Which media plane this client speaks (web-plan.md F4). Absent — every
   * client built before the field existed — reads as UDP, which is what they
   * all speak; prost decodes an absent oneof as None and the gateway treats
   * None as udp. New numbers start at 12: 3–11 are spoken for across the
   * envelope's history and must never be reused.
   *
   * @generated from oneof echo.signal.v1.JoinChannel.transport
   */
  transport: {
    /**
     * @generated from field: echo.signal.v1.UdpJoin udp = 12;
     */
    value: UdpJoin;
    case: "udp";
  } | {
    /**
     * @generated from field: echo.signal.v1.WebRtcJoin webrtc = 13;
     */
    value: WebRtcJoin;
    case: "webrtc";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.signal.v1.JoinChannel.
 * Use `create(JoinChannelSchema)` to create a new message.
 */
export const JoinChannelSchema: GenMessage<JoinChannel> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 8);

/**
 * The classic plane: raw UDP + our 14-byte header + transport AEAD
 * (protocol.md §2). An empty marker — everything it needs already rides
 * JoinAccept's bare fields.
 *
 * @generated from message echo.signal.v1.UdpJoin
 */
export type UdpJoin = Message<"echo.signal.v1.UdpJoin"> & {
};

/**
 * Describes the message echo.signal.v1.UdpJoin.
 * Use `create(UdpJoinSchema)` to create a new message.
 */
export const UdpJoinSchema: GenMessage<UdpJoin> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 9);

/**
 * The browser plane (web-plan.md D49): WebRTC via the SFU-side bridge. The
 * client always creates the offer (as in Meet); the SFU is ICE-lite and
 * answers.
 *
 * @generated from message echo.signal.v1.WebRtcJoin
 */
export type WebRtcJoin = Message<"echo.signal.v1.WebRtcJoin"> & {
  /**
   * @generated from field: string sdp_offer = 1;
   */
  sdpOffer: string;
};

/**
 * Describes the message echo.signal.v1.WebRtcJoin.
 * Use `create(WebRtcJoinSchema)` to create a new message.
 */
export const WebRtcJoinSchema: GenMessage<WebRtcJoin> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 10);

/**
 * @generated from message echo.signal.v1.Participant
 */
export type Participant = Message<"echo.signal.v1.Participant"> & {
  /**
   * @generated from field: uint64 user_id = 1;
   */
  userId: bigint;

  /**
   * u16 on the wire (media header)
   *
   * @generated from field: uint32 sender_id = 2;
   */
  senderId: number;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: bool server_muted = 4;
   */
  serverMuted: boolean;

  /**
   * Last RTT this participant reported to the GW in its VoiceStats, so a
   * joiner sees everyone's ping before the next 10s report (see PeerStats).
   * 0 = not reported yet.
   *
   * @generated from field: uint32 rtt_ms = 5;
   */
  rttMs: number;

  /**
   * Last self-mute state this participant reported in its VoiceState, for the
   * same reason as rtt_ms: a joiner draws the room as it is instead of waiting
   * for everyone to toggle something (see PeerVoiceState).
   *
   * @generated from field: bool muted = 6;
   */
  muted: boolean;

  /**
   * @generated from field: bool deafened = 7;
   */
  deafened: boolean;

  /**
   * Screen sharing settles in the roster for the same reason muted does
   * (screenshare-plan.md D87): somebody joining a call already in progress must
   * see the "Watch stream" button immediately instead of waiting for the next
   * event that will never come.
   *
   * @generated from field: bool screen_sharing = 8;
   */
  screenSharing: boolean;

  /**
   * The source is still shared but is producing no frames — a shared window
   * that got minimized (§8). On the wire that is indistinguishable from a
   * motionless screen, and viewers would stare at a frozen frame without
   * knowing why, so it is said out loud.
   *
   * @generated from field: bool screen_share_paused = 9;
   */
  screenSharePaused: boolean;

  /**
   * Application audio rides along with this share (D98). Only a window share
   * can have it: a monitor has no process of its own.
   *
   * @generated from field: bool screen_share_has_audio = 10;
   */
  screenShareHasAudio: boolean;

  /**
   * From Hello.caps bit 0 — this member's client can watch a stream at all
   * (D91). Absent (an older gateway, or an older client) reads as false, which
   * makes the picker warn about someone who might in fact be fine. That is the
   * right way round: a warning is recoverable, a silent black rectangle is not.
   *
   * @generated from field: bool can_view_screen = 11;
   */
  canViewScreen: boolean;
};

/**
 * Describes the message echo.signal.v1.Participant.
 * Use `create(ParticipantSchema)` to create a new message.
 */
export const ParticipantSchema: GenMessage<Participant> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 11);

/**
 * Also re-pushed by GW when an SFU dies and the room is re-allocated
 * (client reconnects silently — docs/protocol.md §1 Reconnect).
 *
 * @generated from message echo.signal.v1.JoinAccept
 */
export type JoinAccept = Message<"echo.signal.v1.JoinAccept"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * "ip:port" of the SFU worker owning the room
   *
   * @generated from field: string sfu_addr = 2;
   */
  sfuAddr: string;

  /**
   * 32B, one-shot, TTL 60s
   *
   * @generated from field: bytes handshake_token = 3;
   */
  handshakeToken: Uint8Array;

  /**
   * assigned by GW, unique within channel
   *
   * @generated from field: uint32 sender_id = 4;
   */
  senderId: number;

  /**
   * Transport AEAD keys (XChaCha20-Poly1305), generated by GW per session,
   * also delivered to the SFU over the control channel. docs/protocol.md §2.
   *
   * 32B
   *
   * @generated from field: bytes key_c2s = 5;
   */
  keyC2s: Uint8Array;

  /**
   * 32B
   *
   * @generated from field: bytes key_s2c = 6;
   */
  keyS2c: Uint8Array;

  /**
   * 16B
   *
   * @generated from field: bytes nonce_prefix_c2s = 7;
   */
  noncePrefixC2s: Uint8Array;

  /**
   * 16B
   *
   * @generated from field: bytes nonce_prefix_s2c = 8;
   */
  noncePrefixS2c: Uint8Array;

  /**
   * current roster, excluding self
   *
   * @generated from field: repeated echo.signal.v1.Participant participants = 9;
   */
  participants: Participant[];

  /**
   * E2EE (protocol.md §4): id of the channel's MLS group (unique per group
   * incarnation). mls_create=true => joiner is the first participant and must
   * create the group; otherwise it awaits MlsWelcome pushed after the
   * committer's Commit(Add).
   *
   * @generated from field: bytes mls_group_id = 10;
   */
  mlsGroupId: Uint8Array;

  /**
   * @generated from field: bool mls_create = 11;
   */
  mlsCreate: boolean;

  /**
   * The mirror of JoinChannel's transport (web-plan.md F4). For a UDP join
   * the bare fields 2 and 5–8 keep carrying what they always carried — an
   * old client reads them and never sees the oneof. For a WebRTC join those
   * fields are empty (DTLS-SRTP owns the wire crypto and ICE owns the
   * address) and the answer arm is what matters; sender_id (4), the roster
   * (9) and the MLS pair (10–11) are plane-independent and stay bare.
   *
   * @generated from oneof echo.signal.v1.JoinAccept.transport
   */
  transport: {
    /**
     * @generated from field: echo.signal.v1.UdpAccept udp = 12;
     */
    value: UdpAccept;
    case: "udp";
  } | {
    /**
     * @generated from field: echo.signal.v1.WebRtcAccept webrtc = 13;
     */
    value: WebRtcAccept;
    case: "webrtc";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.signal.v1.JoinAccept.
 * Use `create(JoinAcceptSchema)` to create a new message.
 */
export const JoinAcceptSchema: GenMessage<JoinAccept> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 12);

/**
 * @generated from message echo.signal.v1.UdpAccept
 */
export type UdpAccept = Message<"echo.signal.v1.UdpAccept"> & {
};

/**
 * Describes the message echo.signal.v1.UdpAccept.
 * Use `create(UdpAcceptSchema)` to create a new message.
 */
export const UdpAcceptSchema: GenMessage<UdpAccept> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 13);

/**
 * @generated from message echo.signal.v1.WebRtcAccept
 */
export type WebRtcAccept = Message<"echo.signal.v1.WebRtcAccept"> & {
  /**
   * @generated from field: string sdp_answer = 1;
   */
  sdpAnswer: string;
};

/**
 * Describes the message echo.signal.v1.WebRtcAccept.
 * Use `create(WebRtcAcceptSchema)` to create a new message.
 */
export const WebRtcAcceptSchema: GenMessage<WebRtcAccept> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 14);

/**
 * @generated from message echo.signal.v1.JoinReject
 */
export type JoinReject = Message<"echo.signal.v1.JoinReject"> & {
  /**
   * @generated from field: uint32 code = 1;
   */
  code: number;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message echo.signal.v1.JoinReject.
 * Use `create(JoinRejectSchema)` to create a new message.
 */
export const JoinRejectSchema: GenMessage<JoinReject> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 15);

/**
 * C -> GW once the joiner's own call is actually up: media socket bound, audio
 * engine running, MLS group usable. Until it arrives the GW holds the join back
 * — no UserJoined to the room, no call_started/call_participants on the chat
 * socket, no line in the feed — so nobody is shown a participant who cannot yet
 * hear them or be heard (docs/protocol.md §1 "Join flow").
 *
 * Sent only when both ends advertise caps bit 1 (ANNOUNCE_ON_READY): an older
 * GW decodes an unknown oneof arm as an empty envelope and closes the socket,
 * and an older client never sends this, which is why the GW announces such a
 * join the moment it accepts it. Repeats are harmless — the second one finds
 * the join already published and does nothing.
 *
 * @generated from message echo.signal.v1.ChannelReady
 */
export type ChannelReady = Message<"echo.signal.v1.ChannelReady"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;
};

/**
 * Describes the message echo.signal.v1.ChannelReady.
 * Use `create(ChannelReadySchema)` to create a new message.
 */
export const ChannelReadySchema: GenMessage<ChannelReady> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 16);

/**
 * @generated from message echo.signal.v1.LeaveChannel
 */
export type LeaveChannel = Message<"echo.signal.v1.LeaveChannel"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;
};

/**
 * Describes the message echo.signal.v1.LeaveChannel.
 * Use `create(LeaveChannelSchema)` to create a new message.
 */
export const LeaveChannelSchema: GenMessage<LeaveChannel> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 17);

/**
 * @generated from message echo.signal.v1.UserJoined
 */
export type UserJoined = Message<"echo.signal.v1.UserJoined"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: echo.signal.v1.Participant participant = 2;
   */
  participant?: Participant | undefined;
};

/**
 * Describes the message echo.signal.v1.UserJoined.
 * Use `create(UserJoinedSchema)` to create a new message.
 */
export const UserJoinedSchema: GenMessage<UserJoined> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 18);

/**
 * @generated from message echo.signal.v1.UserLeft
 */
export type UserLeft = Message<"echo.signal.v1.UserLeft"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: uint32 sender_id = 3;
   */
  senderId: number;
};

/**
 * Describes the message echo.signal.v1.UserLeft.
 * Use `create(UserLeftSchema)` to create a new message.
 */
export const UserLeftSchema: GenMessage<UserLeft> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 19);

/**
 * @generated from message echo.signal.v1.ServerMuteChanged
 */
export type ServerMuteChanged = Message<"echo.signal.v1.ServerMuteChanged"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: bool muted = 3;
   */
  muted: boolean;
};

/**
 * Describes the message echo.signal.v1.ServerMuteChanged.
 * Use `create(ServerMuteChangedSchema)` to create a new message.
 */
export const ServerMuteChangedSchema: GenMessage<ServerMuteChanged> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 20);

/**
 * C -> GW whenever the client's own microphone/output switches state, and once
 * right after JoinAccept so the room learns the state a client joined with.
 * Unlike ServerMuteChanged (moderation, enforced by the SFU) this is purely
 * presence: the client is the only authority on it and nothing server-side acts
 * on it. A report that does not change the stored state is dropped rather than
 * fanned out.
 *
 * @generated from message echo.signal.v1.VoiceState
 */
export type VoiceState = Message<"echo.signal.v1.VoiceState"> & {
  /**
   * microphone shut by the client itself
   *
   * @generated from field: bool muted = 1;
   */
  muted: boolean;

  /**
   * output off — implies the microphone is shut too
   *
   * @generated from field: bool deafened = 2;
   */
  deafened: boolean;
};

/**
 * Describes the message echo.signal.v1.VoiceState.
 * Use `create(VoiceStateSchema)` to create a new message.
 */
export const VoiceStateSchema: GenMessage<VoiceState> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 21);

/**
 * GW -> the rest of the room whenever a member's VoiceState arrives, so every
 * client can draw who is muted and who cannot hear (protocol.md §1). Not sent
 * back to the reporter — it is the source of the state. Mirrors PeerStats:
 * relayed as-is, at whatever cadence the reporter toggles.
 *
 * @generated from message echo.signal.v1.PeerVoiceState
 */
export type PeerVoiceState = Message<"echo.signal.v1.PeerVoiceState"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: bool muted = 3;
   */
  muted: boolean;

  /**
   * @generated from field: bool deafened = 4;
   */
  deafened: boolean;
};

/**
 * Describes the message echo.signal.v1.PeerVoiceState.
 * Use `create(PeerVoiceStateSchema)` to create a new message.
 */
export const PeerVoiceStateSchema: GenMessage<PeerVoiceState> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 22);

/**
 * GW -> the rest of the room whenever a member's VoiceStats arrives: that
 * member's own RTT to its SFU worker, so every client can show a per-participant
 * ping. Relayed as-is at the reporter's cadence (10s); the GW never measures it
 * itself. Not sent back to the reporter — it already knows its own RTT.
 *
 * @generated from message echo.signal.v1.PeerStats
 */
export type PeerStats = Message<"echo.signal.v1.PeerStats"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: uint32 rtt_ms = 3;
   */
  rttMs: number;
};

/**
 * Describes the message echo.signal.v1.PeerStats.
 * Use `create(PeerStatsSchema)` to create a new message.
 */
export const PeerStatsSchema: GenMessage<PeerStats> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 23);

/**
 * GW -> the last participant when the server itself ends the call: a call that
 * has held no more than one participant for `[call] alone_timeout_s` (5 min by
 * default) is over — nobody answered, or everyone else has left. The room is
 * already gone server-side when this arrives, exactly like ChannelDeleted: the
 * media session is torn down, the MLS group is retired and no UserLeft follows.
 * The channel itself stays; a fresh JoinChannel starts a new call.
 *
 * This is the only server-initiated end a participant can witness — leaving is
 * the client's own move, and a deleted channel has ChannelDeleted — so there is
 * no reason field. protocol.md §1 "Call".
 *
 * @generated from message echo.signal.v1.CallEnded
 */
export type CallEnded = Message<"echo.signal.v1.CallEnded"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;
};

/**
 * Describes the message echo.signal.v1.CallEnded.
 * Use `create(CallEndedSchema)` to create a new message.
 */
export const CallEndedSchema: GenMessage<CallEnded> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 24);

/**
 * GW -> every member of a channel an admin deleted (DELETE /v1/channels/{id}).
 * The room is already gone server-side when this arrives: media is torn down,
 * the MLS group is dropped, and no UserLeft follows. Clients leave the voice
 * view and drop the channel from their list.
 *
 * @generated from message echo.signal.v1.ChannelDeleted
 */
export type ChannelDeleted = Message<"echo.signal.v1.ChannelDeleted"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;
};

/**
 * Describes the message echo.signal.v1.ChannelDeleted.
 * Use `create(ChannelDeletedSchema)` to create a new message.
 */
export const ChannelDeletedSchema: GenMessage<ChannelDeleted> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 25);

/**
 * @generated from message echo.signal.v1.MlsMemberRef
 */
export type MlsMemberRef = Message<"echo.signal.v1.MlsMemberRef"> & {
  /**
   * @generated from field: uint64 user_id = 1;
   */
  userId: bigint;

  /**
   * identity leaf = "user_id:sender_id"
   *
   * @generated from field: uint32 sender_id = 2;
   */
  senderId: number;
};

/**
 * Describes the message echo.signal.v1.MlsMemberRef.
 * Use `create(MlsMemberRefSchema)` to create a new message.
 */
export const MlsMemberRefSchema: GenMessage<MlsMemberRef> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 26);

/**
 * C -> GW: fresh KeyPackage outside of a join (MlsReset recovery flow).
 *
 * @generated from message echo.signal.v1.MlsKeyPackage
 */
export type MlsKeyPackage = Message<"echo.signal.v1.MlsKeyPackage"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: bytes key_package = 2;
   */
  keyPackage: Uint8Array;
};

/**
 * Describes the message echo.signal.v1.MlsKeyPackage.
 * Use `create(MlsKeyPackageSchema)` to create a new message.
 */
export const MlsKeyPackageSchema: GenMessage<MlsKeyPackage> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 27);

/**
 * GW -> committer: create Commit(Add) over these KeyPackages on top of `epoch`.
 *
 * @generated from message echo.signal.v1.MlsAddRequest
 */
export type MlsAddRequest = Message<"echo.signal.v1.MlsAddRequest"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 epoch = 2;
   */
  epoch: bigint;

  /**
   * @generated from field: repeated echo.signal.v1.MlsAddRequest.Candidate add = 3;
   */
  add: MlsAddRequest_Candidate[];
};

/**
 * Describes the message echo.signal.v1.MlsAddRequest.
 * Use `create(MlsAddRequestSchema)` to create a new message.
 */
export const MlsAddRequestSchema: GenMessage<MlsAddRequest> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 28);

/**
 * @generated from message echo.signal.v1.MlsAddRequest.Candidate
 */
export type MlsAddRequest_Candidate = Message<"echo.signal.v1.MlsAddRequest.Candidate"> & {
  /**
   * @generated from field: echo.signal.v1.MlsMemberRef member = 1;
   */
  member?: MlsMemberRef | undefined;

  /**
   * @generated from field: bytes key_package = 2;
   */
  keyPackage: Uint8Array;
};

/**
 * Describes the message echo.signal.v1.MlsAddRequest.Candidate.
 * Use `create(MlsAddRequest_CandidateSchema)` to create a new message.
 */
export const MlsAddRequest_CandidateSchema: GenMessage<MlsAddRequest_Candidate> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 28, 0);

/**
 * GW -> committer: create Commit(Remove) for these members on top of `epoch`.
 * An EMPTY `remove` is the PCS timer (protocol.md §4: periodic empty commit
 * on a stable roster): the committer answers with a commit that changes no
 * membership (openmls self_update of its own leaf) via the usual bundle/ack
 * flow; MlsCommit.removed stays empty, so receivers keep the ordinary 2s key
 * transition window.
 *
 * @generated from message echo.signal.v1.MlsRemoveRequest
 */
export type MlsRemoveRequest = Message<"echo.signal.v1.MlsRemoveRequest"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 epoch = 2;
   */
  epoch: bigint;

  /**
   * @generated from field: repeated echo.signal.v1.MlsMemberRef remove = 3;
   */
  remove: MlsMemberRef[];
};

/**
 * Describes the message echo.signal.v1.MlsRemoveRequest.
 * Use `create(MlsRemoveRequestSchema)` to create a new message.
 */
export const MlsRemoveRequestSchema: GenMessage<MlsRemoveRequest> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 29);

/**
 * committer -> GW: the commit built on `epoch` (group moves to epoch+1),
 * plus Welcome for the added members (Add commits only). The committer keeps
 * the commit PENDING (unmerged) until the DS echoes it back via MlsCommit.
 *
 * @generated from message echo.signal.v1.MlsCommitBundle
 */
export type MlsCommitBundle = Message<"echo.signal.v1.MlsCommitBundle"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 epoch = 2;
   */
  epoch: bigint;

  /**
   * serialized MlsMessageOut (PublicMessage)
   *
   * @generated from field: bytes commit = 3;
   */
  commit: Uint8Array;

  /**
   * empty unless members were added
   *
   * @generated from field: bytes welcome = 4;
   */
  welcome: Uint8Array;

  /**
   * @generated from field: repeated echo.signal.v1.MlsMemberRef added = 5;
   */
  added: MlsMemberRef[];

  /**
   * @generated from field: repeated echo.signal.v1.MlsMemberRef removed = 6;
   */
  removed: MlsMemberRef[];

  /**
   * group incarnation guard: stale bundles are rejected
   *
   * @generated from field: bytes group_id = 7;
   */
  groupId: Uint8Array;
};

/**
 * Describes the message echo.signal.v1.MlsCommitBundle.
 * Use `create(MlsCommitBundleSchema)` to create a new message.
 */
export const MlsCommitBundleSchema: GenMessage<MlsCommitBundle> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 30);

/**
 * GW -> ALL members (committer included — its copy is the accept-ack: commit
 * bytes matching the pending commit => merge now). `epoch` = new epoch.
 * `removed` is filled by the DS from its own op (not trusted from the
 * committer). Non-empty `removed` => senders switch SFrame keys immediately
 * (no 2s transition window) — the rotation's point is cutting off the leaver.
 *
 * @generated from message echo.signal.v1.MlsCommit
 */
export type MlsCommit = Message<"echo.signal.v1.MlsCommit"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 epoch = 2;
   */
  epoch: bigint;

  /**
   * @generated from field: bytes commit = 3;
   */
  commit: Uint8Array;

  /**
   * @generated from field: repeated echo.signal.v1.MlsMemberRef removed = 4;
   */
  removed: MlsMemberRef[];
};

/**
 * Describes the message echo.signal.v1.MlsCommit.
 * Use `create(MlsCommitSchema)` to create a new message.
 */
export const MlsCommitSchema: GenMessage<MlsCommit> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 31);

/**
 * GW -> joiner: join the group at `epoch`.
 *
 * @generated from message echo.signal.v1.MlsWelcome
 */
export type MlsWelcome = Message<"echo.signal.v1.MlsWelcome"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 epoch = 2;
   */
  epoch: bigint;

  /**
   * @generated from field: bytes welcome = 3;
   */
  welcome: Uint8Array;

  /**
   * @generated from field: bytes group_id = 4;
   */
  groupId: Uint8Array;
};

/**
 * Describes the message echo.signal.v1.MlsWelcome.
 * Use `create(MlsWelcomeSchema)` to create a new message.
 */
export const MlsWelcomeSchema: GenMessage<MlsWelcome> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 32);

/**
 * GW -> committer: commit rejected (stale epoch / not the committer).
 * Drop pending state; a new request will follow if still needed.
 *
 * @generated from message echo.signal.v1.MlsCommitReject
 */
export type MlsCommitReject = Message<"echo.signal.v1.MlsCommitReject"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 current_epoch = 2;
   */
  currentEpoch: bigint;
};

/**
 * Describes the message echo.signal.v1.MlsCommitReject.
 * Use `create(MlsCommitRejectSchema)` to create a new message.
 */
export const MlsCommitRejectSchema: GenMessage<MlsCommitReject> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 33);

/**
 * GW -> all: group re-init (plan B for R3). creator=true recreates the group
 * with `group_id`; everyone else replies MlsKeyPackage and awaits MlsWelcome.
 *
 * @generated from message echo.signal.v1.MlsReset
 */
export type MlsReset = Message<"echo.signal.v1.MlsReset"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: bytes group_id = 2;
   */
  groupId: Uint8Array;

  /**
   * @generated from field: bool creator = 3;
   */
  creator: boolean;
};

/**
 * Describes the message echo.signal.v1.MlsReset.
 * Use `create(MlsResetSchema)` to create a new message.
 */
export const MlsResetSchema: GenMessage<MlsReset> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 34);

/**
 * C -> GW on start, on stop, and whenever the source starts or stops producing
 * frames. Modeled on VoiceState: this is presence, and the gateway is the thing
 * that knows the roster, buffers across a resume grace period and understands
 * permissions. The SFU learns nothing from it — forwarding is decided by
 * SubscribeStream on the media plane.
 *
 * @generated from message echo.signal.v1.ScreenShareState
 */
export type ScreenShareState = Message<"echo.signal.v1.ScreenShareState"> & {
  /**
   * @generated from field: bool active = 1;
   */
  active: boolean;

  /**
   * @generated from field: echo.signal.v1.ScreenShareSource source_kind = 2;
   */
  sourceKind: ScreenShareSource;

  /**
   * @generated from field: bool has_audio = 3;
   */
  hasAudio: boolean;

  /**
   * The shared window is minimized or otherwise producing nothing (§8).
   *
   * @generated from field: bool paused = 4;
   */
  paused: boolean;

  /**
   * Only meaningful when active=false. The GW overrides it for the endings it
   * decides itself (leaving the call, an admin stop).
   *
   * @generated from field: echo.signal.v1.ScreenShareEnd reason = 5;
   */
  reason: ScreenShareEnd;
};

/**
 * Describes the message echo.signal.v1.ScreenShareState.
 * Use `create(ScreenShareStateSchema)` to create a new message.
 */
export const ScreenShareStateSchema: GenMessage<ScreenShareState> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 35);

/**
 * GW -> the rest of the room. Not sent back to the streamer — it is the source
 * of the state. Mirrors PeerVoiceState down to that exclusion.
 *
 * @generated from message echo.signal.v1.PeerScreenShare
 */
export type PeerScreenShare = Message<"echo.signal.v1.PeerScreenShare"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean;

  /**
   * @generated from field: echo.signal.v1.ScreenShareEnd reason = 4;
   */
  reason: ScreenShareEnd;

  /**
   * Relayed so a viewer knows what it is about to open before it opens it: a
   * volume control makes no sense without has_audio, and "shared a window" and
   * "shared a screen" read differently in a notification.
   *
   * @generated from field: echo.signal.v1.ScreenShareSource source_kind = 5;
   */
  sourceKind: ScreenShareSource;

  /**
   * @generated from field: bool has_audio = 6;
   */
  hasAudio: boolean;

  /**
   * @generated from field: bool paused = 7;
   */
  paused: boolean;
};

/**
 * Describes the message echo.signal.v1.PeerScreenShare.
 * Use `create(PeerScreenShareSchema)` to create a new message.
 */
export const PeerScreenShareSchema: GenMessage<PeerScreenShare> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 36);

/**
 * GW -> the would-be second streamer: somebody is already sharing (D86). One
 * active stream per call, and the refusal names the current streamer so the
 * client can say who without a second lookup.
 *
 * A dedicated message rather than the generic Error because the client has to
 * do something specific with it — close its own picker and point at a
 * participant — and because PeerScreenShare is deliberately never sent to the
 * person it is about, so the requester would otherwise learn nothing.
 *
 * @generated from message echo.signal.v1.ScreenShareRejected
 */
export type ScreenShareRejected = Message<"echo.signal.v1.ScreenShareRejected"> & {
  /**
   * @generated from field: uint64 channel_id = 1;
   */
  channelId: bigint;

  /**
   * @generated from field: uint64 current_user_id = 2;
   */
  currentUserId: bigint;
};

/**
 * Describes the message echo.signal.v1.ScreenShareRejected.
 * Use `create(ScreenShareRejectedSchema)` to create a new message.
 */
export const ScreenShareRejectedSchema: GenMessage<ScreenShareRejected> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 37);

/**
 * C -> GW every 10s while a stream is running, and only from the people in it:
 * the streamer and its viewers (D90). VoiceStats is sent by everyone always,
 * and hanging these fields on it would mean paying for them in every call of
 * every user when 95% of calls have no stream at all.
 *
 * @generated from message echo.signal.v1.ScreenShareStats
 */
export type ScreenShareStats = Message<"echo.signal.v1.ScreenShareStats"> & {
  /**
   * @generated from field: uint32 bitrate_kbps = 1;
   */
  bitrateKbps: number;

  /**
   * @generated from field: uint32 fps = 2;
   */
  fps: number;

  /**
   * @generated from field: uint32 frames_dropped = 3;
   */
  framesDropped: number;

  /**
   * @generated from field: uint32 keyframes_requested = 4;
   */
  keyframesRequested: number;

  /**
   * Filled by the streamer (it is the only side that knows); a viewer sends 0.
   *
   * @generated from field: uint32 viewers = 5;
   */
  viewers: number;

  /**
   * false = this report comes from a viewer, so bitrate/fps describe what it
   * received rather than what was sent.
   *
   * @generated from field: bool sending = 6;
   */
  sending: boolean;
};

/**
 * Describes the message echo.signal.v1.ScreenShareStats.
 * Use `create(ScreenShareStatsSchema)` to create a new message.
 */
export const ScreenShareStatsSchema: GenMessage<ScreenShareStats> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 38);

/**
 * client -> GW every 10s while in a channel
 *
 * @generated from message echo.signal.v1.VoiceStats
 */
export type VoiceStats = Message<"echo.signal.v1.VoiceStats"> & {
  /**
   * @generated from field: float loss_pct = 1;
   */
  lossPct: number;

  /**
   * @generated from field: uint32 rtt_ms = 2;
   */
  rttMs: number;

  /**
   * @generated from field: float jitter_ms = 3;
   */
  jitterMs: number;

  /**
   * % of frames concealed by PLC
   *
   * @generated from field: float concealment_pct = 4;
   */
  concealmentPct: number;

  /**
   * current encoder bitrate
   *
   * @generated from field: uint32 bitrate_bps = 5;
   */
  bitrateBps: number;
};

/**
 * Describes the message echo.signal.v1.VoiceStats.
 * Use `create(VoiceStatsSchema)` to create a new message.
 */
export const VoiceStatsSchema: GenMessage<VoiceStats> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 39);

/**
 * @generated from message echo.signal.v1.Error
 */
export type Error = Message<"echo.signal.v1.Error"> & {
  /**
   * @generated from field: uint32 code = 1;
   */
  code: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message echo.signal.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_echo_signal_v1_signal, 40);

/**
 * @generated from enum echo.signal.v1.ScreenShareSource
 */
export enum ScreenShareSource {
  /**
   * @generated from enum value: SCREEN_SHARE_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCREEN_SHARE_SOURCE_MONITOR = 1;
   */
  MONITOR = 1,

  /**
   * @generated from enum value: SCREEN_SHARE_SOURCE_WINDOW = 2;
   */
  WINDOW = 2,
}

/**
 * Describes the enum echo.signal.v1.ScreenShareSource.
 */
export const ScreenShareSourceSchema: GenEnum<ScreenShareSource> = /*@__PURE__*/
  enumDesc(file_echo_signal_v1_signal, 0);

/**
 * Why a share ended. A code and not a string: §10 requires every string on the
 * stream screen to exist in both Lang::Ru and Lang::En, with a missing English
 * one being a compile error — and a server-supplied sentence can satisfy
 * neither. The client turns this into a localized toast.
 *
 * @generated from enum echo.signal.v1.ScreenShareEnd
 */
export enum ScreenShareEnd {
  /**
   * @generated from enum value: SCREEN_SHARE_END_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * the streamer pressed stop
   *
   * @generated from enum value: SCREEN_SHARE_END_STOPPED = 1;
   */
  STOPPED = 1,

  /**
   * the window closed / the monitor was unplugged
   *
   * @generated from enum value: SCREEN_SHARE_END_SOURCE_GONE = 2;
   */
  SOURCE_GONE = 2,

  /**
   * the streamer left, or their resume grace expired
   *
   * @generated from enum value: SCREEN_SHARE_END_LEFT_CALL = 3;
   */
  LEFT_CALL = 3,

  /**
   * moderation (POST /v1/channels/{id}/screenshare/stop)
   *
   * @generated from enum value: SCREEN_SHARE_END_ADMIN_STOPPED = 4;
   */
  ADMIN_STOPPED = 4,
}

/**
 * Describes the enum echo.signal.v1.ScreenShareEnd.
 */
export const ScreenShareEndSchema: GenEnum<ScreenShareEnd> = /*@__PURE__*/
  enumDesc(file_echo_signal_v1_signal, 1);

